import { connect } from 'react-redux';
import * as actions from './Actions';
import * as selector from './Selector';
import View from './View';

interface RouterContainerProps {
  defaultController: string;
  defaultParams?: any;
  forceDefaultRoute?: boolean;
}

const mapStateToProps = (
  state,
  { defaultController, defaultParams, forceDefaultRoute }: RouterContainerProps,
) => ({
  currentRoute: selector.currentRouteSelector(state),
  defaultController,
  defaultParams,
  forceDefaultRoute,
});

const mapDispatchToProps = dispatch => ({
  setCurrentRoute(route) {
    dispatch(actions.setCurrentRoute(route));
  },
});

export default AreaComponent => connect(mapStateToProps, mapDispatchToProps)(View(AreaComponent));
